import { render, staticRenderFns } from "./custom-select-tag-head.vue?vue&type=template&id=6a9a9077&"
import script from "./custom-select-tag-head.vue?vue&type=script&lang=js&"
export * from "./custom-select-tag-head.vue?vue&type=script&lang=js&"
import style0 from "./custom-select-tag-head.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a9a9077')) {
      api.createRecord('6a9a9077', component.options)
    } else {
      api.reload('6a9a9077', component.options)
    }
    module.hot.accept("./custom-select-tag-head.vue?vue&type=template&id=6a9a9077&", function () {
      api.rerender('6a9a9077', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/custom-select/custom-select-tag-head.vue"
export default component.exports